import {Basic, Ventrata} from 'types'
import {getGa4BookingItems} from './getGa4BookingItems'

export const getGa4OrderItems = (
  order: Ventrata.Order,
  currency: Basic.Currency,
  crossSelling: Record<string, boolean>
) => {
  const items = []

  for (const booking of order.bookings) {
    items.push(...getGa4BookingItems(booking, currency, crossSelling[booking.uuid]))
  }

  return items
}
